const configs = {
  spoty: {
    PRIMARY_COLOR: "bg-blue-600", // Classname from Tailwind
    SECOND_COLOR: "", // Classname from Tailwind
    TITLE_TOP_HEADER: "Spoty",
    HERO_MAIN_TITLE: "Spoty",
    HERO_MAIN_SUBTITLE: "Parking",
    HERO_MAIN_MASCOT: "",
    HERO_MAIN_DESCRIPTION:
      "Find a spot was never so easy. A community driven app to allow you find the best spot to your vehicle.",
    HERO_MAIN_IMAGE: require("./../images/Hero Image.png"), //1084x709
    STORES_LINKS: [],
    HOW_IT_WORKS_ITEMS: [
      {
        TITLE: "You download the app",
        DESCRIPTION:
          "The first step is download the app and help us to improve it. We are 100% dedicated to receive feedbacks and to improve the service and the software.",
        IMAGE: require("./../images/screen3.png"), //429x862
      },
      {
        TITLE: "You check for available parking spaces",
        DESCRIPTION:
          "Here is the step where you find new spot and check if it will fits your needs.",
        IMAGE: require("./../images/screen2.png"),
      },
      {
        TITLE: "You contribute",
        DESCRIPTION:
          "The last step is the most important. Sharing the available spaces around you and validating the parking spaces is the core way to make the ecosystem safe and effective.",
        IMAGE: require("./../images/screen4.png"),
      },
    ],
    TESTIMONIALS: [
      {
        PLACE: "Berlin, Germany",
        AUTHOR: "Holley O.",
        COMMENT:
          "I am really satisfied with my Spoty parking. I'd be lost without Spoty parking.",
      },
      {
        PLACE: "Braga, Portugal",
        AUTHOR: "Marthena",
        COMMENT:
          "You've saved so much time! Spoty parking has really helped our business. It's really wonderful.",
      },
      {
        PLACE: "Lisbon, Portugal",
        AUTHOR: "Ferdinando N.",
        COMMENT:
          "Spoty parking is the real deal! I use Spoty parking often. Great job, I will definitely be using again!",
      },
      {
        PLACE: "Berlin, Germany",
        AUTHOR: "Ferguson P.",
        COMMENT:
          "I will refer everyone I know. It's just amazing. Thanks to Spoty parking, everyon in my family is using it.",
      },
    ],
    SHOW_FAQS: true,
    FAQS: [
      {
        QUESTION: "What is the Spoty Parking?",
        ANSWER:
          "Spoty Parking is a community-driven app allowing drivers to help each other to find an available parking spot.",
      },
      {
        QUESTION: "How is the availability of a parking space checked?",
        ANSWER:
          "All parking spaces are based on validations from user to user, that means we trust user to validate new parking spaces.",
      },
      {
        QUESTION: "When it will be available in my city",
        ANSWER:
          "Spoty is totally based on community, which means the app is working on the entire world but it needs people from different parts of the world to support the app.",
      },
      {
        QUESTION: "Is it paid?",
        ANSWER:
          "No. Spoty is totally free, we have plans to allow the user receives updates in real-time with contributors monitoring the parking spaces but this is a later step for us.",
      },
    ],
    FOOTER_EMAIL_SUBSCRIPTION: true,
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_U: "4c699f1d92f4f76f91f81b8c6",
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_ID: "b35bf73418",
    FOOTER_APP_NAME: "Spoty Parking",
  },
  "guia-de-bolso-cristao": {
    PRIMARY_COLOR: "bg-yellow-900", // Classname from Tailwind
    SECOND_COLOR: "", // Classname from Tailwind
    TITLE_TOP_HEADER: "Guia de Bolso Cristão",
    HERO_MAIN_TITLE: "Guia de Bolso",
    HERO_MAIN_SUBTITLE: "Cristão",
    HERO_MAIN_MASCOT: "",
    HERO_MAIN_DESCRIPTION:
      "Manter-se conectado com a sua fé nunca foi tão fácil. Uma aplicação impulsionada pela comunidade para permitir que você tenha acesso a recursos e ferramentas espirituais a qualquer momento.",
    HERO_MAIN_IMAGE: require("./../images/guia_de_bolso_cristao/hero_image.png"), //1084x709
    STORES_LINKS: [],
    HOW_IT_WORKS_ITEMS: [
      {
        TITLE: "Você faz o download do aplicativo",
        DESCRIPTION:
          "O primeiro passo é fazer o download do aplicativo e ajudar-nos a melhorá-lo. Estamos 100% dedicados a receber feedbacks e a melhorar o serviço e o software.",
        IMAGE: require("./../images/guia_de_bolso_cristao/splashscreen.png"), //429x862
      },
      {
        TITLE: "Você personaliza sua experiência",
        DESCRIPTION:
          "Com o Guia de Bolso Cristão, você pode personalizar sua experiência de acordo com suas necessidades espirituais. Escolha entre diferentes ferramentas, como orações, reflexões diárias e muito mais.",
        IMAGE: require("./../images/guia_de_bolso_cristao/home.png"),
      },
      {
        TITLE: "Você se conecta com a sua fé",
        DESCRIPTION:
          "Com o Guia de Bolso Cristão, você pode se conectar com a sua fé a qualquer momento e em qualquer lugar. Tenha acesso a recursos espirituais sempre que precisar de uma fonte de inspiração e orientação.",
        IMAGE: require("./../images/guia_de_bolso_cristao/procurar_topico.png"),
      },
    ],
    TESTIMONIALS: [
      {
        PLACE: "São Paulo, Brasil",
        AUTHOR: "Marina S.",
        COMMENT:
          "Eu amo o Guia de Bolso Cristão. Ele me ajuda a manter-me conectada com a fé todos os dias.",
      },
      {
        PLACE: "Rio de Janeiro, Brasil",
        AUTHOR: "Felipe N.",
        COMMENT:
          "O Guia de Bolso Cristão é essencial para a minha vida espiritual. Eu recomendo a todos.",
      },
      {
        PLACE: "Lisboa, Portugal",
        AUTHOR: "Marta P.",
        COMMENT:
          "Eu adoro o Guia de Bolso Cristão. Ele tem me ajudado a ter uma conexão mais forte com Deus.",
      },
      {
        PLACE: "Madri, Espanha",
        AUTHOR: "Juan C.",
        COMMENT:
          "O Guia de Bolso Cristão é a minha fonte diária de inspiração e orientação espiritual.",
      },
    ],
    SHOW_FAQS: false,
    FAQS: [],
    FOOTER_EMAIL_SUBSCRIPTION: false,
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_U: "4c699f1d92f4f76f91f81b8c6",
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_ID: "b35bf73418",
    FOOTER_APP_NAME: "Guia de Bolso Cristão",
  },
  freshcura: {
    PRIMARY_COLOR: "bg-amber-500", // Classname from Tailwind
    SECOND_COLOR: "", // Classname from Tailwind
    TITLE_TOP_HEADER: "Freshcura",
    HERO_MAIN_TITLE: "FRESHCURA",
    HERO_MAIN_SUBTITLE: "",
    HERO_MAIN_MASCOT: "",
    HERO_MAIN_DESCRIPTION:
      "Manter-se conectado com a sua fé nunca foi tão fácil. Uma aplicação impulsionada pela comunidade para permitir que você receba notificação da sua comida favorita a qualquer momento.",
    HERO_MAIN_IMAGE: require("./../images/freshcura/hero-image.png"), //1084x709
    STORES_LINKS: [],
    HOW_IT_WORKS_ITEMS: [
      {
        TITLE: "Você faz o download do aplicativo",
        DESCRIPTION:
          "O primeiro passo é fazer o download do aplicativo e ajudar-nos a melhorá-lo. Estamos 100% dedicados a receber feedbacks e a melhorar o serviço e o software.",
        IMAGE: require("./../images/freshcura/onboarding.png"), //429x862
      },
      {
        TITLE: "Você personaliza sua experiência",
        DESCRIPTION:
          "Com o Freshcura, você pode personalizar sua experiência de acordo com suas necessidades. Escolha seus alertas, notificações e muito mais.",
        IMAGE: require("./../images/freshcura/home.png"),
      },
      {
        TITLE: "Receba notificações e comida fresca",
        DESCRIPTION:
          "Com o Freshcura, você recebe notificações e alertas sempre que sua comida favorita estiver disponível.",
        IMAGE: require("./../images/freshcura/notifications.png"),
      },
    ],
    TESTIMONIALS: [
      {
        PLACE: "São Paulo, Brasil",
        AUTHOR: "Marina S.",
        COMMENT:
          "Eu amo o Freshcura. Ele me ajuda a comer pão fresco todos os dias da minha padaria favorita.",
      },
      {
        PLACE: "Rio de Janeiro, Brasil",
        AUTHOR: "Felipe N.",
        COMMENT:
          "O Freshcura é incrível. Eu recomendo a todos que querem comer comida fresca.",
      },
      {
        PLACE: "Lisboa, Portugal",
        AUTHOR: "Marta P.",
        COMMENT: "Eu adoro o Freshcura. Simples e eficaz.",
      },
      {
        PLACE: "Madri, Espanha",
        AUTHOR: "Juan C.",
        COMMENT:
          "O Freshcura ajudou a minha padaria a vender mais. Obrigado Freshcura.",
      },
    ],
    SHOW_FAQS: false,
    FAQS: [],
    FOOTER_EMAIL_SUBSCRIPTION: false,
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_U: "4c699f1d92f4f76f91f81b8c6",
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_ID: "b35bf73418",
    FOOTER_APP_NAME: "Freshcura",
  },
  "little-pilgrim": {
    PRIMARY_COLOR: "bg-green-800", // Classname from Tailwind
    SECOND_COLOR: "", // Classname from Tailwind
    TITLE_TOP_HEADER: "Little Pilgrim",
    HERO_MAIN_TITLE: "Little Pilgrim",
    HERO_MAIN_MASCOT: require("./../images/little_pilgrim/wait.gif"),
    HERO_MAIN_SUBTITLE: "",
    HERO_MAIN_DESCRIPTION:
      "Deixe seu filho aprender inglês de forma divertida e eficaz e com princípios cristãos.",
    HERO_MAIN_IMAGE: require("./../images/little_pilgrim/pilgrimlandscape.webp"), //1084x709
    STORES_LINKS: [
      {
        type: "android",
        url: "https://play.google.com/store/apps/details?id=com.littlepilgrim",
      },
      {
        type: "apple",
        url: "https://apps.apple.com/us/app/little-pilgrim-aprender-ingl%C3%AAs/id6499377784",
      },
    ],
    HOW_IT_WORKS_ITEMS: [
      {
        TITLE: "Download do aplicativo",
        DESCRIPTION:
          "O primeiro passo é fazer o download do aplicativo e ajudar-nos a melhorá-lo. Estamos 100% dedicados a receber feedbacks e a melhorar o serviço e o software.",
        IMAGE: require("./../images/little_pilgrim/wait.gif"), //429x862
      },
    ],
    TESTIMONIALS: [],
    SHOW_FAQS: false,
    FAQS: [],
    FOOTER_EMAIL_SUBSCRIPTION: false,
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_U: "4c699f1d92f4f76f91f81b8c6",
    FOOTER_EMAIL_SUBSCRIPTION_MAILCHIMP_ID: "b35bf73418",
    FOOTER_APP_NAME: "Little Pilgrim",
  },
};

export default configs;
